import SiteHeader from "@/components/SiteHeader";
import Hero from "@/components/Hero";
import SiteFooter from "@/components/SiteFooter";
import MissionFocusCard from "@/components/home/MissionFocusCard";
import HomeStatsRow from "@/components/home/HomeStatsRow";
import HomeIdeasStrip from "@/components/home/HomeIdeasStrip";
import HomeInsightsFeature from "@/components/home/HomeInsightsFeature";
import HomeBottomCtas from "@/components/home/HomeBottomCtas";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader variant="hero" />
      <main id="main">
        <Hero />
        <MissionFocusCard />
        <HomeIdeasStrip />
        <HomeStatsRow />
        <HomeInsightsFeature />
        <HomeBottomCtas />
      </main>
      <SiteFooter />
    </div>
  );
};

export default Index;
